import React, { Component } from 'react'

import SegmentData from './SegmentData'

class SegmentFull extends Component {
  state = {
    expand: this.props.expand || false,
    name: null,
  }

  toggleFullView = (ev) => {
    this.setState({ expand: !this.state.expand });
  }

  propsChange = (name, stats) => {
    this.setState({ name });
  }

  render() {
    const { name } = this.state;
    const { save, download, params, data } = this.props;
    
    return (
      <div>
        { this.state.expand ? 
          <SegmentData 
            search={params.request} 
            propsChange={this.propsChange}
            toggleFullView={this.toggleFullView} 
          />
          :
          <div className="autosuggest__item" onClick={this.toggleFullView}>
            <div className="ai__request">
              Everyone who likes 
            <span className="ai__request-item"> { name || params.request }</span>
            </div>
            <div className="ai">
              <div className="ai__data ai__new">New {data.new}%</div>
              <div className="ai__data ai__unengaged">Unengaged {data.unengaged}%</div>
              <div className="ai__data ai__regulars">Regulars {data.regulars}%</div>
              {/* <div className="ai__data ai__peoples">Total {getRandomInt(0, 21581)} / 21581</div> */}
              { save && <div className="ai__button">Save</div>}
              { download && <div className="ai__button">Download</div>}
            </div>
          </div>
        }
      </div>
    )
  }
}


export default SegmentFull


// WEBPACK FOOTER //
// ./src/components/SegmentFull.js